/**
 * @file swagger-ui-init.js
 * @description Initialisation de SwaggerUI pour la documentation API.
 *
 * `loadSwaggerUI` vient de `init-swagger-ui.js` du bundle NelmioApiDoc, chargé
 * par balise `<script>` juste avant : d'où l'attente de `load` et non de
 * `DOMContentLoaded`.
 */

import { reportError } from './report-error';

/** Ordre d'affichage des verbes HTTP ; tout verbe inconnu passe en dernier. */
const METHOD_ORDER = { get: 0, post: 1, put: 2, patch: 3, delete: 4 };

/**
 * Trie les opérations par verbe puis par chemin.
 *
 * @param {Map} first
 * @param {Map} second
 * @returns {number}
 */
function compareOperations(first, second)
{
    const firstMethod = METHOD_ORDER[first.get('method')] ?? 99;
    const secondMethod = METHOD_ORDER[second.get('method')] ?? 99;

    if (firstMethod !== secondMethod) {
        return firstMethod - secondMethod;
    }

    return first.get('path').localeCompare(second.get('path'));
}

// `loadSwaggerUI` lit `SwaggerUIStandalonePreset` pour construire ses options par défaut, même
// quand l'appelant fournit les siennes : sans ce garde-fou, retirer le <script> du preset
// provoquerait une ReferenceError.
window.SwaggerUIStandalonePreset ??= null;

window.addEventListener('load', function () {
    const node = document.getElementById('swagger-ui-config');
    if (!node) {
        return;
    }

    if (typeof loadSwaggerUI !== 'function' || !window.SwaggerUIBundle) {
        reportError('SwaggerUI scripts not loaded');
        return;
    }

    let baseConfig;
    try {
        baseConfig = JSON.parse(node.textContent);
    } catch (error) {
        reportError('Invalid SwaggerUI config', error);
        return;
    }

    loadSwaggerUI({
        ...baseConfig,
        // `StandaloneLayout` (défaut du bundle) rend une topbar déjà masquée en CSS, dont le
        // logo SVG injecte un <style> inline refusé par `style-src-elem`. `BaseLayout` s'en
        // passe : plus de violation CSP, et le preset standalone (261 ko) n'est plus chargé.
        presets: [window.SwaggerUIBundle.presets.apis],
        layout: 'BaseLayout',
        operationsSorter: compareOperations,
        defaultModelsExpandDepth: -1,
    });
});
